import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const FarmRegistration = lazy(() => import('../../container/admin/farm/farmRegistration'));
const FarmList = lazy(() => import('../../container/admin/farm/farmList'));
const FarmUpdate = lazy(() => import('../../container/admin/farm/farmUpdate'));
// const FarmDetails = lazy(() => import('../../container/admin/farm/farmDetails'));
const FarmDetails = lazy(() => import('../../container/admin/farm/FarmDetail/farmDetails'));

function FarmRoute() {
  return (
    <Routes>
      <Route path="registration" element={<FarmRegistration />} />
      <Route path="list" element={<FarmList />} />
      <Route path="update/:farmId" element={<FarmUpdate />} />
      <Route path="details/:farmId" element={<FarmDetails />} />
      {/* <Route path="details/:farmerId" element={<FarmView />} /> */}
    </Routes>
  );
}

export default FarmRoute;
